const SPOTLIGHT_RESET_DATE = () => process.env.REACT_APP_SPOTLIGHT_RESET_DATE;

export default SPOTLIGHT_RESET_DATE;
